import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../../../components/navbar';
import Footer from '../../../../components/footer';
import Button from '../../../../components/Button';
import Checkbox from '../../../../components/Checkbox';
import { useConsultation } from '../../../../context/ConsultationContext';
import { handleTreatmentServiceNavigation } from '../components/treatmentNavigationHelper';
import baseStyles from './css/BloodPressure.module.css';
import styles from './css/Hemoglobin.module.css';
import { Droplet, Send } from 'lucide-react';

const Hemoglobin = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { consultationData, updateConsultationData, getStepDraft, setStepDraft, goToStep } = useConsultation();

    const patient = location?.state?.patient || consultationData?.patient || {};
    const patientName = `${patient?.firstname || ""} ${patient?.surname || ""}`.trim() || "Thandiwe Ndlovu";
    const profileNumber = patient?.profilenumber || "448896";
    const initials = `${patient?.firstname?.[0] || ""}${patient?.surname?.[0] || ""}`.toUpperCase() || "TN";

    // Test results states
    const [hbLevel, setHbLevel] = useState('');

    // Other states
    const [clinicalNotes, setClinicalNotes] = useState('');
    const [ironDeficiencyHistory, setIronDeficiencyHistory] = useState(false);

    const [symptoms, setSymptoms] = useState({
        fatigue: false,
        paleSkin: false,
        shortnessOfBreath: false
    });

    const handleSymptomChange = (symptom) => {
        setSymptoms(prev => ({
            ...prev,
            [symptom]: !prev[symptom]
        }));
    };

    const handleInvoice = () => {
        handleTreatmentServiceNavigation({
            location,
            navigate,
            consultationData,
            updateConsultationData,
            getStepDraft,
            setStepDraft,
            goToStep,
            serviceData: {
                hemoglobin_test: {
                    hbLevel,
                    clinicalNotes,
                    ironDeficiencyHistory,
                    symptoms,
                },
            },
        });
    };

    useEffect(() => {
        document.body.classList.add(styles.hideSidebar);
        return () => {
            document.body.classList.remove(styles.hideSidebar);
        };
    }, []);

    return (
        <div className={baseStyles.bloodPressureContainer}>
            <Navbar />

            <main className={styles.mainContent}>
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <div className={styles.headerIcon} aria-hidden="true">
                            <Droplet />
                        </div>
                        <h1 className={styles.title}>Hemoglobin Test</h1>
                    </div>

                    <div className={styles.patientCard}>
                        <div className={styles.avatar} aria-hidden="true">{initials}</div>
                        <div className={styles.patientText}>
                            <div className={styles.patientName}>{patientName}</div>
                            <div className={styles.patientMetaRow}>
                                <span className={styles.profileInfo}>Profile: {profileNumber}</span>
                                <span className={styles.dependentBadge}>Dependent</span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>READINGS</div>
                        <div className={styles.readingsRow}>
                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Hb Level</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="number"
                                        value={hbLevel}
                                        onChange={(e) => setHbLevel(e.target.value)}
                                        className={baseStyles.readingInput}
                                        placeholder='120'
                                    />
                                    <span className={styles.unit}>g/dL</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>SYMPTOMS &amp; HISTORY</div>

                        <div className={styles.symptomsList}>
                            <div className={styles.checkboxItem}>
                                <Checkbox
                                    id="fatigue"
                                    checked={symptoms.fatigue}
                                    onChange={() => handleSymptomChange('fatigue')}
                                />
                                <label htmlFor="fatigue" className={styles.checkboxLabel}>Fatigue</label>
                            </div>

                            <div className={styles.checkboxItem}>
                                <Checkbox
                                    id="paleSkin"
                                    checked={symptoms.paleSkin}
                                    onChange={() => handleSymptomChange('paleSkin')}
                                />
                                <label htmlFor="paleSkin" className={styles.checkboxLabel}>Pale Skin</label>
                            </div>

                            <div className={styles.checkboxItem}>
                                <Checkbox
                                    id="shortnessOfBreath"
                                    checked={symptoms.shortnessOfBreath}
                                    onChange={() => handleSymptomChange('shortnessOfBreath')}
                                />
                                <label htmlFor="shortnessOfBreath" className={styles.checkboxLabel}>Shortness of breath</label>
                            </div>
                        </div>

                        <div className={styles.toggleSection}>
                            <label className={styles.toggleLabel}>Iron deficiency history</label>
                            <button
                                type="button"
                                className={`${styles.toggleButton} ${ironDeficiencyHistory ? styles.active : ''}`}
                                onClick={() => setIronDeficiencyHistory(!ironDeficiencyHistory)}
                                aria-pressed={ironDeficiencyHistory}
                            >
                                <div className={styles.toggleSlider}></div>
                            </button>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.fieldLabel}>Clinical Notes</div>
                        <textarea
                            value={clinicalNotes}
                            onChange={(e) => setClinicalNotes(e.target.value)}
                            className={styles.clinicalNotes}
                            placeholder="Enter clinical notes..."
                            rows={6}
                        />
                    </div>

                    <div className={styles.cardFooter}>
                        <Button
                            onClick={handleInvoice}
                            className={styles.invoiceButton}
                            type="button"
                        >
                            <Send size={16} />
                            Invoice
                        </Button>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Hemoglobin;